import { makeOptional } from "../routeHelper"

export const templates = {
  id: "library",
  config: "/library",
  build: () => "/library",
  children: [
    {
      id: "libraryCollections",
      config: "/library/collections",
      build: () => `/library/collections`,
    },
    {
      id: "libraryItems",
      config: "/library/items",
      build: () => `/library/items`,
    },
    {
      id: "libraryMedia",
      config: "/library/media",
      build: () => `/library/media`,
    },
    {
      id: "collectionsOverview",
      config: "/library/:currentTab?",
      build: (currentTab) => `/library/${currentTab}`,
    },
    {
      id: "collectionItemsQuestionV2",
      config: "/library/question-editor/v2/collections/:collectionId/items/:id",
      build: (collectionId, id, type, revision) => revision ?
        `/library/question-editor/v2/collections/${collectionId}/items/${id}?type=${type}&revision=${revision}`
        : `/library/question-editor/v2/collections/${collectionId}/items/${id}?type=${type}`,
    },
    {
      id: "collectionItemsQuestion",
      config: "/library/question-editor/v1/collections/:collectionId/items/:id/:tab?",
      build: (collectionId, id, type, tab ) =>
        `/library/question-editor/v1/collections/${collectionId}/items/${id}${makeOptional(
          tab,
        )}?type=${type}`,
    },
    {
      id: "collectionItemsQuestion_Legacy",
      config: "/library/collections/:collectionId/items/:id/:tab?",
      build: (collectionId, id, type, tab) =>
        `/library/collections/${collectionId}/items/${id}${makeOptional(tab)}?type=${type}`,
    },

    // NEW ROUTES
    {
      id: "libraryCollectionContent",
      config: "/library/collections/:collectionId",
      build: (collectionId) => `/library/collections/${collectionId}`,
    },
    {
      id: "libraryCollectionItems",
      config: "/library/collections/:collectionId/items",
      build: (collectionId) => `/library/collections/${collectionId}/items`,
    },
    {
      id: "libraryCollectionStatistics",
      config: "/library/collections/:collectionId/statistics",
      build: (collectionId) => `/library/collections/${collectionId}/statistics`,
    },
    {
      id: "libraryCollectionStatisticsVersions",
      config: "/library/collections/:collectionId/statistics/:itemId",
      build: (collectionId, itemId) => `/library/collections/${collectionId}/statistics/${itemId}`,
    },
    // NEW ROUTES END

    {
      id: "collectionItems",
      config: "/library/collections/:collectionId/:currentTab?",
      build: (collectionId, currentTab) => {
        if (["items", "statistics"].indexOf(currentTab) === -1) currentTab = ""

        return `/library/collections/${collectionId}/${currentTab}`
      },
    },
    {
      id: "collectionItemsImport",
      config: "/library/import/:id/:optional?",
      build: (id, optional) => `/library/import/${id}/${optional}`,
    },
    {
      id: "sharingPage",
      config: "/library/sharing/:id",
      build: (id) => `/library/sharing/${id}`,
      children: [
        {
          id: "sharingCollection",
          config: "/library/sharing/:id/collection",
          build: (id) => `/library/sharing/${id}/collection`,
        },
        {
          id: "sharingQuestion",
          config: "/library/sharing/:id/questions",
          build: (id) => `/library/sharing/${id}/questions`,
        },
        {
          id: "sharingOverview",
          config: "/library/sharing/:id/overview",
          build: (id) => `/library/sharing/${id}/overview`,
        },
      ],
    },
  ],
}
